module.exports = __webpack_public_path__ + "media/counting.1e9854c5.mp3";